<template>
  <div class="page login">
    <div class="card shadow-4 mx-auto mb-5" style="max-width: 500px">
      <div class="card-body">
        <h5 class="text-primary">{{ printLang('MyAccount.Login.NotLoguedIn') }}</h5>
        <form id="form_login" role="form" action="#" class="px-5" @submit.prevent="formLogin()">
          <div class="form-group">
            <label for="email">{{ printLang('Global.Email') }}&nbsp;:&nbsp;</label>
            <input type="email" name="email" class="form-control" required :placeholder="printLang('Global.Email')">
          </div>
          <div class="form-group">
            <label for="password">{{ printLang('Global.Password') }}&nbsp;:&nbsp;</label>
            <input type="password" name="password" class="form-control" required :placeholder="printLang('Global.Password')">
          </div>
          <transition name="slide-fade">
            <p v-if="errorMessage" class="alert alert-danger my-3">{{ errorMessage }}</p>
          </transition>
          <div class="form-group text-center">
            <button :disabled="loading" class="btn btn-success" type="submit">
              {{ printLang('MyAccount.Login.LogIn') }}
            </button>
          </div>
        </form>
        <div class="pl-5"><a href="./creer-un-compte-gratuit">{{ printLang('MyAccount.Login.NotHaveAccount') }}</a></div>
      </div>
    </div>
  </div>
</template>

<script>
  import apiSrv from './apiSrv';
  import { printLang } from './lang';

  export default {
    data() {
      return {
        printLang,
        errorMessage: "",
        loading: false,
      };
    },
    created() {
      sessionStorage.clear();
    },
    methods: {
      formLogin() {
        this.errorMessage = "";
        this.loading = true;
        const thisform = $("#form_login");
        const data = thisform.serialize();
        apiSrv.call(`${window.api.users.url }/login`, 'POST', data).then((result) => {
          localStorage.api_token = result.token;
          window.location.replace(`${window.location.protocol}//${window.location.host}${window.location.pathname}`);
        }).catch((result) => {
          const response = result.responseText ? JSON.parse(result.responseText) : {};
          this.errorMessage = window.formatApiAnswer(response.message) || `Something went wrong. ${result.statusText}`;
          this.loading = false;
        });
      },
    },
  };
</script>
